module.exports = __webpack_public_path__ + "img/SKMJ_lift6.5075da68.jpg";